import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { verifyDeviceAuthToken } from "./schema/auth/verify-device-auth-token";
import { enableDeviceAuth } from "./schema/device-auth/enable-device-auth";
import { listDeviceAuth } from "./schema/device-auth/list-device-auth";
import { refreshDeviceToken } from "./schema/device-auth/refresh-device-token";
import { revokeDeviceAuth } from "./schema/device-auth/revoke-device-auth";
import { verifyFileExchangeAccess } from "./schema/file-exchange/verify-file-exchange-access";
import { requestEmailOtp } from "./schema/otp/request-email-otp";
import { verifyEmailOtp } from "./schema/otp/verify-email-otp";
import { reportPasswordLoginError } from "./schema/password/report-password-login-error";
import { requestPasswordLogin } from "./schema/password/request-password-login";
import { verifyPassword } from "./schema/password/verify-password";

// Group related endpoints
const authEndpoints = { verifyDeviceAuthToken };
const deviceAuthEndpoints = {
  enableDeviceAuth,
  listDeviceAuth,
  revokeDeviceAuth,
  refreshDeviceToken,
};
const fileExchangeEndpoints = { verifyFileExchangeAccess };
const otpEndpoints = { requestEmailOtp, verifyEmailOtp };
const passwordEndpoints = {
  requestPasswordLogin,
  verifyPassword,
  reportPasswordLoginError,
};

export const rpcDefinition = {
  ...authEndpoints,
  ...deviceAuthEndpoints,
  ...fileExchangeEndpoints,
  ...otpEndpoints,
  ...passwordEndpoints,
};

export type AuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
